

export default function Portfolio() {
    return (
        <div id="portfolio-page">
            <h1>portfolio page</h1>
 
        </div>
    )
}
